import { render, staticRenderFns } from "./TableBaseV2.vue?vue&type=template&id=5ad75d70&scoped=true&"
import script from "./TableBaseV2.vue?vue&type=script&lang=js&"
export * from "./TableBaseV2.vue?vue&type=script&lang=js&"
import style0 from "./TableBaseV2.vue?vue&type=style&index=0&id=5ad75d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad75d70",
  null
  
)

export default component.exports